export default {
  data() {
    return {
      isLandscape: window.innerWidth > window.innerHeight,
      tranName: window.innerWidth > window.innerHeight ? 'fade' : 'slide-up'
    };
  }
};
